import { apiClient } from "../../../lib/axios";
import type {
  PreRegistrationQuestionsResponse,
  PreRegistrationResponsesRequest,
  PreRegistrationResponsesResponse,
} from "./types";

export const preRegistrationApi = {
  getQuestions: async (params?: {
    client_id?: string | null;
  }): Promise<PreRegistrationQuestionsResponse> => {
    const response = await apiClient.get("/pre-registration/questions", {
      params: params?.client_id ? { client_id: params.client_id } : undefined,
    });
    return response.data;
  },

  submitResponses: async (
    data: PreRegistrationResponsesRequest
  ): Promise<PreRegistrationResponsesResponse> => {
    const response = await apiClient.post("/pre-registration/responses", data);
    return response.data;
  },
};
